import { useTransition } from '@react-spring/core';
import { animated } from '@react-spring/web';
import React, { useState } from 'react'
import { Alert, MoContainer } from '../Mo7/mo7UI';

export default function Test() {
    const [show, set] = useState(false)
    const transitions = useTransition(show, {
        from: { opacity: 0, x: 10 },
        enter: { opacity: 1, x: 0 },
        leave: { opacity: 0, x: 10 },

    })
    return <div style={{ marginLeft: "5rem" }}>
        <button onClick={() => set(!show)}>toggle</button>
        {transitions(
            (styles, item) => item && <animated.div style={styles}>
                <Alert onClick={() => console.log("still here")} w='fit-content' danger>Danger</Alert>
            </animated.div>
        )}
        <MoContainer demo wh="2rem">
            <svg viewBox="10 10 10 10">
                <rect
                    x="10" y="10"
                    width='100%' height="100%"
                />
            </svg>
        </MoContainer>

    </div>
}

